import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  ContentListReq,
  ContentListRes,
  CreateContentReq,
  ActionContentRes,
  DeleteContentReq,
  ContentDetailReq,
  ContentDetailRes,
  PagenameReq,
  PagenameRes,
} from './types'

export const getContentListAction = createAsyncAction(
  'CONTENT/GET_CONTENT_LIST_REQ',
  'CONTENT/GET_CONTENT_LIST_SUCCESS',
  'CONTENT/GET_CONTENT_LIST_FAILURE',
)<ContentListReq, ContentListRes, Error>()

export const getContentDetailAction = createAsyncAction(
  'CONTENT/GET_CONTENT_DETAIL_REQ',
  'CONTENT/GET_CONTENT_DETAIL_SUCCESS',
  'CONTENT/GET_CONTENT_DETAIL_FAILURE',
)<ContentDetailReq, ContentDetailRes, Error>()

export const createContentAction = createAsyncAction(
  'CONTENT/CREATE_CONTENT_REQ',
  'CONTENT/CREATE_CONTENT_SUCCESS',
  'CONTENT/CREATE_CONTENT_FAILURE',
)<CreateContentReq, ActionContentRes, Error>()

export const deleteContentAction = createAsyncAction(
  'CONTENT/DELETE_CONTENT_REQ',
  'CONTENT/DELETE_CONTENT_SUCCESS',
  'CONTENT/DELETE_CONTENT_FAILURE',
)<DeleteContentReq, ActionContentRes, Error>()

export const getPagenameListAction = createAsyncAction(
  'CONTENT/GET_PAGENAME_LIST_REQ',
  'CONTENT/GET_PAGENAME_SUCCESS',
  'CONTENT/GET_PAGENAME_FAILURE',
)<PagenameReq, PagenameRes, Error>()

export const clearEventAction = createStandardAction('CONTENT/CLEAR_EVENT')<void>()

export const resetDetailAction = createStandardAction('CONTENT/RESET_DETAIL')<void>()
